module.exports = __webpack_public_path__ + "bv.svg?ce747379b653d0c81d931cd25779c857";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/bv.svg
// module id = 1022
// module chunks = 0